const muster = require('./src/muster-core/src');
module.exports = muster;
